import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const SERIES_CONFIG = [
  { key: 'pdcPct', label: 'PDC %', color: '#6366F1' },
  { key: 'mprPct', label: 'MPR %', color: '#22C55E' },
  { key: 'floorMetPct', label: 'Floor Met %', color: '#F97316' },
];

const buildChartOptions = (categories) => ({
  chart: { type: 'line', toolbar: { show: false }, fontFamily: 'inherit' },
  stroke: { curve: 'smooth', width: 2 },
  colors: SERIES_CONFIG.map((s) => s.color),
  markers: { size: 4 },
  dataLabels: { enabled: false },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'right',
    fontSize: '12px',
    labels: { colors: '#6B7280' },
  },
  xaxis: {
    type: 'datetime',
    categories,
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { colors: '#9CA3AF', fontSize: '12px' } },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 4,
    labels: {
      formatter: (v) => `${v}%`,
      style: { colors: '#9CA3AF', fontSize: '12px' },
    },
  },
  grid: { borderColor: '#F3F4F6', strokeDashArray: 4 },
  tooltip: {
    y: { formatter: (v) => `${v}%` },
  },
});

const MPRTrendChart = ({ requestData }) => {
  const [mrtTrendData, setMrtTrendData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getMPRTrendChart(requestData);

        setMrtTrendData(data.data || []);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const categories = mrtTrendData.map((r) => r.date);

  const series = SERIES_CONFIG.map((s) => ({
    name: s.label,
    data: mrtTrendData.map((r) => r[s.key] ?? 0),
  }));

  return (
    <div className={classes.chart_kpi_wrapper}>
      <p style={{
        margin: '16px 0 0 16px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        MPR Trend
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : !mrtTrendData.length
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <Chart
              type="line"
              height={320}
              series={series}
              options={buildChartOptions(categories)}
            />
          )}
    </div>
  );
};

export default MPRTrendChart;
